import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { storeKENNumber, storeSONumber, resetIOTData, setPendingToStartSurvey, fetchEquipmentIOTData } from '../../application_actions';
import { Navigator } from '../presentational/navigator.jsx';
import { Input } from '../presentational/input.jsx';
import { LoadingCircular } from '../presentational/loading.jsx';

import makeBasePage from '../base_page.jsx';

export class ValidateEquipment extends Component {

  constructor(props) {
    super(props);

    this.validationRequestId = 0;

    this.state = {
      KEN: (this.props.app.KEN || undefined),
      eqpType: undefined,
      isValidating: false,
      unsupportedEquipmentError: false,
    }
  }

  componentDidMount() {
    this.props.resetIOTData();
    this.initFlow()
    this.initKen();
  }

  initFlow(){
    if(!this.props.progress.flow || !this.props.progress.flow.length){
      if(this.props.location.pathname === '/site_survey/validate-equipment'){
        this.props.selectFlow('site_survey',0)
      }else{ 
        this.props.history.push('/main');
      }
    }
  }

  initKen() {
    const urlParamKen = new URLSearchParams(this.props.location.search).get('KEN');
    const urlParamServiceOrder = new URLSearchParams(this.props.location.search).get('SO');
    let ken = undefined
    if(urlParamKen) {
      ken = urlParamKen
    } else if(this.props.app.KEN) {
      ken = this.props.app.KEN
    }
    this.setState({
      KEN: (ken || undefined)
    });

    if (ken && urlParamServiceOrder) {
      this.storeServiceOrderNumber(ken, urlParamServiceOrder);
    }
  }

  storeServiceOrderNumber(ken, serviceOrder) {
    if (serviceOrder) {
      this.props.storeSONumber(serviceOrder);
    } else {
      this.props.storeSONumber('-');
    }
  }

  onKENChange(value) {
    this.setState({
      KEN: value,
      eqpType: undefined,
      isValidating: false,
      unsupportedEquipmentError: false,
    })
  }

  isContinueDisabled() {
    if(this.props.app.internetStatus){
      return this.state.KEN == undefined || this.state.KEN.length != 8 || this.state.isValidating || this.state.unsupportedEquipmentError
    }
    return true
  }

  async submitData() {
    if(this.props.app.KEN !== this.state.KEN) this.props.setPendingToStartSurvey(undefined)
    const submittedKEN = this.state.KEN;
    const cachedEquipment = this.props.app.iotData?.equipment;
    const hasCachedDataForSameKEN =
      this.props.app.KEN === submittedKEN &&
      cachedEquipment?.EquipmentNumberKENformatted === submittedKEN;
    
    this.props.storeKENNumber(submittedKEN);
    this.storeServiceOrderNumber(submittedKEN, this.props.app.SO);

    let result;
    if (hasCachedDataForSameKEN) {
      result = {
        ok: true,
        equipment: this.props.app.iotData,
      };
    } else {
      const requestId = ++this.validationRequestId;
      this.setState({ isValidating: true });
      result = await this.props.fetchEquipmentIOTData(submittedKEN);

      // Ignore stale responses when user has already edited KEN again.
      if (requestId !== this.validationRequestId || this.state.KEN !== submittedKEN) {
        return;
      }
    }

    const eqpType = result?.equipment?.equipment?.EquipmentGeneralEquipmentType;

    if (result?.ok && eqpType !== '004') {
      this.setState({
        eqpType,
        isValidating: false,
        unsupportedEquipmentError: true,
      });
      return;
    }

    this.setState({
      eqpType,
      isValidating: false,
      unsupportedEquipmentError: false,
    });

    this.props.goForward();
  }

  render() {

    return (
      <div className="page-view" id="register-equipment">
        <h1>
          {this.props.strings.ValidateEquipment.enterEquipmentNumber}
        </h1>
        <div>
          <Input
            label={this.props.strings.KoneEquipment.KEN}
            onInputChange={(value) => this.onKENChange(value)}
            value={this.state.KEN || ''}
            minLength={8}
            maxLength={8}
            lengthText={this.props.strings.Common.digits}
            valid={ this.state.KEN !== undefined && this.state.KEN.length == 8 }
          />
          {this.state.isValidating && <LoadingCircular />}
          {this.state.unsupportedEquipmentError && (
            <div className="unsupported-equipment-error">
              <span className="unsupported-equipment-icon warning-icon" aria-hidden="true" />
              <p>{this.props.strings.KoneEquipment.unsupportedEquipmentError || "Equipment entered is not supported by 24/7 Site Survey Tool"}</p>
            </div>
          )}
        </div>        
        <Navigator
          continueText={this.props.strings.ValidateEquipment.validateKEN}
          backText={this.props.strings.Common.back}
          onContinue={ () => this.submitData() }
          onBack={() => this.props.goBack() }
          continueDisabled={ this.isContinueDisabled() }
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ storeKENNumber, storeSONumber, resetIOTData, setPendingToStartSurvey, fetchEquipmentIOTData }, dispatch);
}

export default connect(null, mapDispatchToProps)(makeBasePage('ValidateEquipment')(ValidateEquipment));
